import { ISEOWaterObj } from './constants';

/*
  This is hardcoded SEO data
  It is the top ranking pages according to our amplitude data
  In the future this should be stored and fetched from the backend.
  ATTENTION: These links wont work on staging db because the fishingWaterIds are different there.
*/

export const TOP_PERFORMING_WATERS: ISEOWaterObj[] = [
  { locationName: 'Kennel Branch', fishingWaterId: 'oL4K3jQu' },
  { locationName: "Bois d'Arc Lake", fishingWaterId: 'obVmccjN' },
  { locationName: 'Lake Balboa', fishingWaterId: 'MHZytRPl' },
  { locationName: 'Sandusky River @ Fremont', fishingWaterId: 'Q9ctpfHu' },
  { locationName: 'Pymatuning Lake', fishingWaterId: 'KrYDRYSW' },
  { locationName: 'Puddingstone Reservoir', fishingWaterId: 'C36bTqsT' },
  { locationName: 'Manasquan Inlet', fishingWaterId: 'VC2_BtaO' },
  { locationName: 'Kent Lake', fishingWaterId: 'oYJHyYqA' },
  { locationName: 'Mark Twain Lake', fishingWaterId: 'hjExSdmP' },
  { locationName: 'Lake Henshaw', fishingWaterId: 'i3qKiLvn' },
  { locationName: 'Lynx Lake', fishingWaterId: 'OiA1QMq1' },
  { locationName: 'Tibble Fork Reservoir', fishingWaterId: 'M3VCeKKt' },
];
